module.exports = __webpack_public_path__ + "img/25.76c6cae0.svg";